const ProcedureButton = ({onClick, text, background}) => {
    return (
        <button className={`${background} rounded-lg p-2 w-[30%] uppercase vibrate-1`} onClick={()=>onClick()}>{text}</button>
    );
}
 
export default ProcedureButton;